import { inject } from '@angular/core';
import { MixpanelEvents } from '../models/mixpanelEvents';
import { MixpanelService } from './mixpanel.service';

export const redirectEquipmentResolver = () => {
	const mixpanelService: MixpanelService = inject(MixpanelService);
	mixpanelService.trackPage(MixpanelEvents.RedirectToEquipment);
	return true;
}
